import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const NotificationBarIconWrapper = styled.div`
  align-self: flex-start;

  & > svg {
    min-width: ${props => props.theme.notification.icon.width};
    height: ${props => props.theme.notification.icon.height};

    ${breakpoint('mobile')`
      min-width: ${props => props.theme.notification.icon.mobile.width};
      height: ${props => props.theme.notification.icon.mobile.height};
    `};
  }
`

export default NotificationBarIconWrapper
